import { useEffect } from "react";
import AOS from "aos";

const ManagementTeam = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);

  return (
    <div className="management" data-aos="fade-up">
      <h1 className="text-center">Leadership Team</h1>
      <div className="management-team" >
        <div className="">
          <img src={`${process.env.PUBLIC_URL}/assets/img/Habila-Musa-Luka.jpeg`} alt="img" className="leader-photos overide"  />
          <h1>Habila Musa-Luka</h1>
          <p>MD/CEO</p>
        </div>

        <div className="">
          <img src={`${process.env.PUBLIC_URL}/assets/img/oluwaseyi-bangide.png`} alt="img" className="leader-photos" />
          <h1>Oluwaseyi Banigbe</h1>
          <p> Chairperson, Board of Directors</p>
        </div>

        <div className="">
          <img src={`${process.env.PUBLIC_URL}/assets/img/udus-photo.jpg`} alt="img" className="leader-photos" />
          <h1>Udukheli Izebuno</h1>
          <p> Non-executive Director</p>
        </div>

        <div className="">
          <img src={`${process.env.PUBLIC_URL}/assets/img/wuraolaoluwa.jpg`} alt="img" className="leader-photos" />
          <h1>Wuraolaoluwa Ogungbola</h1>
          <p>  Non-executive Director</p>
        </div>


        <div className="">
          <img src={`${process.env.PUBLIC_URL}/assets/img/folajimi.jpg`} alt="img" className="leader-photos" />
          <h1>Folajimi Adeleye</h1>
          <p> Non-Executive Director</p>
        </div>


        <div className="">
          <img src={`${process.env.PUBLIC_URL}/assets/img/kule-awolowo.jpg`} alt="img" className="leader-photos" />
          <h1>Kunle Awolowo</h1>
          <p> Independent Non-Executive Director</p>
        </div>

      </div>
    </div>
  );
};

export default ManagementTeam;
